!function(t,n){"object"==typeof exports&&"undefined"!=typeof module?n(exports):"function"==typeof define&&define.amd?define(["exports"],n):n((t="undefined"!=typeof globalThis?globalThis:t||self).htmlToImage={})}(this,(function(t){"use strict";
function n(t,n,e,r){return new(e||(e=Promise))((function(o,i){function u(t){try{f(r.next(t))}catch(t){i(t)}}function c(t){try{f(r.throw(t))}catch(t){i(t)}}function f(t){var n;t.done?o(t.value):(n=t.value,n instanceof e?n:new e((function(t){t(n)}))).then(u,c)}f((r=r.apply(t,n||[])).next())}))}function e(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(i){return function(c){return function(i){if(e)throw new TypeError("Generator is already executing.");for(;u;)try{if(e=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=u.trys,(o=o.length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=n.call(t,u)}catch(t){i=[6,t],r=0}finally{e=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,c])}}}var r="application/font-woff",o="image/jpeg",i={woff:r,woff2:r,ttf:"application/font-truetype",eot:"application/vnd.ms-fontobject",png:"image/png",jpg:o,jpeg:o,gif:"image/gif",tiff:"image/tiff",svg:"image/svg+xml"};function u(t){var n=function(t){var n=/\.([^./]*?)$/g.exec(t);return n?n[1]:""}(t).toLowerCase();return i[n]||""}function c(t){return-1!==t.search(/^(data:)/)}function f(t,n){return"data:"+n+";base64,"+t}var a,s=(a=0,function(){return a+=1,"u"+("0000"+(Math.random()*Math.pow(36,4)<<0).toString(36)).slice(-4)+a});function l(t){for(var n=[],e=0,r=t.length;e<r;e+=1)n.push(t[e]);return n}function h(t,n){var e=window.getComputedStyle(t).getPropertyValue(n);return parseFloat(e.replace("px",""))}function d(t){return t.toBlob?new Promise((function(n){return t.toBlob(n)})):new Promise((function(n){for(var e=window.atob(t.toDataURL().split(",")[1]),r=e.length,o=new Uint8Array(r),i=0;i<r;i+=1)o[i]=e.charCodeAt(i);n(new Blob([o],{type:"image/png"}))}))}function v(t){return new Promise((function(n,e){var r=new Image;r.onload=function(){return n(r)},r.onerror=e,r.crossOrigin="anonymous",r.decoding="sync",r.src=t}))}function p(t){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,Promise.resolve().then((function(){return(new XMLSerializer).serializeToString(t)})).then(encodeURIComponent).then((function(t){return"data:image/svg+xml;charset=utf-8,"+t}))]}))}))}var g={};function m(t,n){var e=function(t){var n=t.replace(/\?.*/,"");return/ttf|otf|eot|woff2?/i.test(n)&&(n=n.replace(/.*\//,"")),n}(t);if(null!=g[e])return g[e];n.cacheBust&&(t+=(/\?/.test(t)?"&":"?")+(new Date).getTime());var r=window.fetch(t).then((function(t){return t.blob().then((function(n){return{blob:n,contentType:t.headers.get("Content-Type")||""}}))})).then((function(t){var n=t.blob,e=t.contentType;return new Promise((function(t,r){var o=new FileReader;o.onloadend=function(){return t({contentType:e,blob:o.result})},o.onerror=r,o.readAsDataURL(n)}))})).then((function(t){var n,e=t.blob;return{contentType:t.contentType,blob:(n=e,n.split(/,/)[1])}})).catch((function(e){var r="";if(n.imagePlaceholder){var o=n.imagePlaceholder.split(/,/);o&&o[1]&&(r=o[1])}var i="Failed to fetch resource: "+t;return e&&(i="string"==typeof e?e:e.message),i&&console.error(i),{blob:r,contentType:""}}));return g[e]=r,r}function w(t,n,e){var r="."+t+":"+n,o=e.cssText?function(t){var n=t.getPropertyValue("content");return t.cssText+" content: '"+n.replace(/'|"/g,"")+"';"}(e):function(t){return l(t).map((function(n){return n+": "+t.getPropertyValue(n)+(t.getPropertyPriority(n)?" !important":"")+";"})).join(" ")}(e);return document.createTextNode(r+"{"+o+"}")}function b(t,n,e){var r=window.getComputedStyle(t,e),o=r.getPropertyValue("content");if(""!==o&&"none"!==o){var i=s();try{n.className=n.className+" "+i}catch(t){return}var u=document.createElement("style");u.appendChild(w(i,e,r)),n.appendChild(u)}}function y(t){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return"data:,"===(n=t.toDataURL())?[2,Promise.resolve(t.cloneNode(!1))]:[2,v(n)]}))}))}function P(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,Promise.resolve(t.poster).then((function(t){return m(t,r)})).then((function(n){return f(n.blob,u(t.poster)||n.contentType)})).then((function(t){return v(t)}))]}))}))}function S(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return r instanceof Element?[2,Promise.resolve().then((function(){return function(t,n){var e=window.getComputedStyle(t),r=n.style;r&&(e.cssText?r.cssText=e.cssText:l(e).forEach((function(t){r.setProperty(t,e.getPropertyValue(t),e.getPropertyPriority(t))})))}(t,r)})).then((function(){return function(t,n){b(t,n,":before"),b(t,n,":after")}(t,r)})).then((function(){return function(t,n){t instanceof HTMLTextAreaElement&&(n.innerHTML=t.value),t instanceof HTMLInputElement&&n.setAttribute("value",t.value)}(t,r)})).then((function(){return r}))]:[2,Promise.resolve(r)]}))}))}function x(t,r,o){return n(this,void 0,void 0,(function(){return e(this,(function(i){return o||!r.filter||r.filter(t)?[2,Promise.resolve(t).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return t instanceof HTMLCanvasElement?[2,y(t)]:t instanceof HTMLVideoElement&&t.poster?[2,P(t,r)]:[2,Promise.resolve(t.cloneNode(!1))]}))}))}(t,r)})).then((function(o){return function(t,r,o){var i;return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){var u;return 0===(n=null!=(u=t).tagName&&"SLOT"===u.tagName.toUpperCase()&&t.assignedNodes?l(t.assignedNodes()):l((null!==(i=t.shadowRoot)&&void 0!==i?i:t).childNodes)).length||t instanceof HTMLVideoElement?[2,Promise.resolve(r)]:[2,n.reduce((function(t,n){return t.then((function(){return x(n,o)})).then((function(t){t&&r.appendChild(t)}))}),Promise.resolve()).then((function(){return r}))]}))}))}(t,o,r)})).then((function(n){return S(t,n)}))]:[2,Promise.resolve(null)]}))}))}var E=/url\((['"]?)([^'"]+?)\1\)/g,T=/url\([^)]+\)\s*format\((["'])([^"']+)\1\)/g,C=/src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;function R(t){var n=[];return t.replace(E,(function(t,e,r){return n.push(r),t})),n.filter((function(t){return!c(t)}))}function L(t,n,e,r,o){var i=e?function(t,n){if(t.match(/^[a-z]+:\/\//i))return t;if(t.match(/^\/\//))return window.location.protocol+t;if(t.match(/^[a-z]+:/i))return t;var e=document.implementation.createHTMLDocument(),r=e.createElement("base"),o=e.createElement("a");return e.head.appendChild(r),e.body.appendChild(o),n&&(r.href=n),o.href=t,o.href}(n,e):n;return Promise.resolve(i).then((function(t){return o?o(t):m(t,r)})).then((function(t){return"string"==typeof t?f(t,u(n)):f(t.blob,u(n)||t.contentType)})).then((function(e){return t.replace((r=n.replace(/([.*+?^${}()|\[\]\/\\])/g,"\\$1"),new RegExp("(url\\(['\"]?)("+r+")(['\"]?\\))","g")),"$1"+e+"$3");var r})).then((function(t){return t}),(function(){return i}))}function N(t){return-1!==t.search(E)}function k(t,r,o){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return N(t)?(n=function(t,n){var e=n.preferredFontFormat;return e?t.replace(C,(function(t){for(;;){var n=T.exec(t)||[],r=n[0],o=n[2];if(!o)return"";if(o===e)return"src: "+r+";"}})):t}(t,o),[2,Promise.resolve(n).then(R).then((function(t){return t.reduce((function(t,n){return t.then((function(t){return L(t,n,r,o)}))}),Promise.resolve(n))}))]):[2,Promise.resolve(t)]}))}))}function A(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(o){return t instanceof Element?[2,Promise.resolve(t).then((function(t){return function(t,r){var o;return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return(n=null===(o=t.style)||void 0===o?void 0:o.getPropertyValue("background"))?[2,Promise.resolve(n).then((function(t){return k(t,null,r)})).then((function(n){return t.style.setProperty("background",n,t.style.getPropertyPriority("background")),t}))]:[2,Promise.resolve(t)]}))}))}(t,r)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return t instanceof HTMLImageElement&&!c(t.src)||t instanceof SVGImageElement&&!c(t.href.baseVal)?(n=t instanceof HTMLImageElement?t.src:t.href.baseVal,[2,Promise.resolve(n).then((function(t){return m(t,r)})).then((function(t){return f(t.blob,u(n)||t.contentType)})).then((function(n){return new Promise((function(e,r){t.onload=e,t.onerror=r,t instanceof HTMLImageElement?(t.srcset="",t.src=n):t.href.baseVal=n}))})).then((function(){return t}),(function(){return t}))]):[2,Promise.resolve(t)]}))}))}(t,r)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){var n,o;return e(this,(function(e){return n=l(t.childNodes),o=n.map((function(t){return A(t,r)})),[2,Promise.all(o).then((function(){return t}))]}))}))}(t,r)}))]:[2,Promise.resolve(t)]}))}))}var I={};function M(t){var n=I[t];if(null!=n)return n;var e=window.fetch(t).then((function(n){return{url:t,cssText:n.text()}}));return I[t]=e,e}function D(t){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,t.cssText.then((function(n){var e=n,r=/url\(["']?([^"')]+)["']?\)/g,o=(e.match(/url\([^)]+\)/g)||[]).map((function(n){var o=n.replace(r,"$1");return o.startsWith("https://")||(o=new URL(o,t.url).href),window.fetch(o).then((function(t){return t.blob()})).then((function(t){return new Promise((function(r,o){var i=new FileReader;i.onloadend=function(){e=e.replace(n,"url("+i.result+")"),r([n,i.result])},i.onerror=o,i.readAsDataURL(t)}))}))}));return Promise.all(o).then((function(){return e}))}))]}))}))}function V(t){if(null==t)return[];for(var n=[],e=t.replace(/(\/\*[\s\S]*?\*\/)/gi,""),r=new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})","gi");;){if(null===(u=r.exec(e)))break;n.push(u[0])}e=e.replace(r,"");for(var o=/@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi,i=new RegExp("((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})","gi");;){var u;if(null===(u=o.exec(e))){if(null===(u=i.exec(e)))break;o.lastIndex=i.lastIndex}else i.lastIndex=o.lastIndex;n.push(u[0])}return n}function H(t){return t.filter((function(t){return t.type===CSSRule.FONT_FACE_RULE})).filter((function(t){return N(t.style.getPropertyValue("src"))}))}function U(t){return n(this,void 0,void 0,(function(){return e(this,(function(r){return[2,new Promise((function(n,e){null==t.ownerDocument&&e(new Error("Provided element is not within a Document")),n(l(t.ownerDocument.styleSheets))})).then((function(t){return function(t){return n(this,void 0,void 0,(function(){var n,r;return e(this,(function(e){return n=[],r=[],t.forEach((function(n){if("cssRules"in n)try{l(n.cssRules).forEach((function(t,e){if(t.type===CSSRule.IMPORT_RULE){var o=e+1,i=M(t.href).then((function(t){return t?D(t):""})).then((function(t){return V(t).forEach((function(t){try{n.insertRule(t,t.startsWith("@import")?o+=1:n.cssRules.length)}catch(n){console.error("Error inserting rule from remote css",{rule:t,error:n})}}))})).catch((function(t){console.error("Error loading remote css",t.toString())}));r.push(i)}}))}catch(o){var e=t.find((function(t){return null==t.href}))||document.styleSheets[0];null!=n.href&&r.push(M(n.href).then((function(t){return t?D(t):""})).then((function(t){return V(t).forEach((function(t){e.insertRule(t,n.cssRules.length)}))})).catch((function(t){console.error("Error loading remote stylesheet",t.toString())}))),console.error("Error inlining remote css file",o.toString())}})),[2,Promise.all(r).then((function(){return t.forEach((function(t){if("cssRules"in t)try{l(t.cssRules).forEach((function(t){n.push(t)}))}catch(n){console.error("Error while reading CSS rules from "+t.href,n.toString())}})),n}))]}))}))}(t)})).then(H)]}))}))}function j(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,U(t).then((function(t){return Promise.all(t.map((function(t){var n=t.parentStyleSheet?t.parentStyleSheet.href:null;return k(t.cssText,n,r)})))})).then((function(t){return t.join("\n")}))]}))}))}function F(t,n){void 0===n&&(n={});var e=n.width||function(t){var n=h(t,"border-left-width"),e=h(t,"border-right-width");return t.clientWidth+n+e}(t),r=n.height||function(t){var n=h(t,"border-top-width"),e=h(t,"border-bottom-width");return t.clientHeight+n+e}(t);return{width:e,height:r}}function B(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){var o,i,u;return e(this,(function(c){return o=F(t,r),i=o.width,u=o.height,[2,Promise.resolve(t).then((function(t){return x(t,r,!0)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,(null!=r.fontEmbedCSS?Promise.resolve(r.fontEmbedCSS):j(t,r)).then((function(n){var e=document.createElement("style"),r=document.createTextNode(n);return e.appendChild(r),t.firstChild?t.insertBefore(e,t.firstChild):t.appendChild(e),t}))]}))}))}(t,r)})).then((function(t){return A(t,r)})).then((function(t){return function(t,n){var e=t.style;n.backgroundColor&&(e.backgroundColor=n.backgroundColor),n.width&&(e.width=n.width+"px"),n.height&&(e.height=n.height+"px");var r=n.style;return null!=r&&Object.keys(r).forEach((function(t){e[t]=r[t]})),t}(t,r)})).then((function(t){return function(t,r,o){return n(this,void 0,void 0,(function(){var n,i,u;return e(this,(function(e){return n="http://www.w3.org/2000/svg",i=document.createElementNS(n,"svg"),u=document.createElementNS(n,"foreignObject"),i.setAttribute("width",""+r),i.setAttribute("height",""+o),i.setAttribute("viewBox","0 0 "+r+" "+o),u.setAttribute("width","100%"),u.setAttribute("height","100%"),u.setAttribute("x","0"),u.setAttribute("y","0"),u.setAttribute("externalResourcesRequired","true"),i.appendChild(u),u.appendChild(t),[2,p(i)]}))}))}(t,i,u)}))]}))}))}var O=16384;function $(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,B(t,r).then(v).then((function(n){var e=document.createElement("canvas"),o=e.getContext("2d"),i=r.pixelRatio||function(){var t,n;try{n=process}catch(t){}var e=n&&n.env?n.env.devicePixelRatio:null;return e&&(t=parseInt(e,10),Number.isNaN(t)&&(t=1)),t||window.devicePixelRatio||1}(),u=F(t,r),c=u.width,f=u.height,a=r.canvasWidth||c,s=r.canvasHeight||f;return e.width=a*i,e.height=s*i,r.skipAutoScale||function(t){(t.width>O||t.height>O)&&(t.width>O&&t.height>O?t.width>t.height?(t.height*=O/t.width,t.width=O):(t.width*=O/t.height,t.height=O):t.width>O?(t.height*=O/t.width,t.width=O):(t.width*=O/t.height,t.height=O))}(e),e.style.width=""+a,e.style.height=""+s,r.backgroundColor&&(o.fillStyle=r.backgroundColor,o.fillRect(0,0,e.width,e.height)),o.drawImage(n,0,0,e.width,e.height),e}))]}))}))}t.getFontEmbedCSS=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,j(t,r)]}))}))},t.toBlob=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then(d)]}))}))},t.toCanvas=$,t.toJpeg=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then((function(t){return t.toDataURL("image/jpeg",r.quality||1)}))]}))}))},t.toPixelData=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){var n,o,i;return e(this,(function(e){return n=F(t,r),o=n.width,i=n.height,[2,$(t,r).then((function(t){return t.getContext("2d").getImageData(0,0,o,i).data}))]}))}))},t.toPng=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then((function(t){return t.toDataURL()}))]}))}))},t.toSvg=B,Object.defineProperty(t,"__esModule",{value:!0})}));

const saveModalBtn = document.getElementById('saveModal')
saveModalBtn.addEventListener('click' , (e) => {
    htmlToImage.toJpeg(document.getElementById('reportModal'), { quality: 0.95 })
  .then(function (dataUrl) {
    var link = document.createElement('a');
    var rptFileName = identifier.patient
    link.download = `${rptFileName}.jpeg`;
    link.href = dataUrl;
    link.click();
  });
    console.log(e);
});

function boldString(str, substr) {
    var strRegExp = new RegExp(substr, 'g');
    return str.replace(strRegExp, '<b><i>'+substr+'</i></b>');
  }

  const newWorkBtn = document.querySelector("#worksheets-btn");
  newWorkBtn.addEventListener("click", (e) => {
    checkID();
    showModal('patientId');
    
    console.log(e);
  });
  const dispRegion = document.getElementById('confirmRegion');
  const sonoLine = document.getElementById('sono')
  function displayIdRegions () {
      dispRegion.style.display = 'block';
      
  }
  
  
  function showPatID() {
    document.getElementById("patientId").style.display = "block";
  }
  
  
  const togMenuBtn = document.querySelector("#togMenu");
  
  togMenuBtn.addEventListener("click", (e) => {
    myFunction();
    console.log(e);
  });
  function myFunction() {
    var x = document.getElementById("navDemo");
    if (x.className.indexOf("w3-show") == -1) {
      x.className += " w3-show";
    } else {
      x.className = x.className.replace(" w3-show", "");
    }
  }
  function printReport() {
    document.getElementById("nonPrintable").className += "noPrint";
    window.print();
  }
  const printReportBtn = document.querySelector("#printReport");
  printReportBtn.addEventListener("click", (e) => {
    printReport();
    console.log(e);
  });
  
  function showReportModal() {
    document.getElementById("reportModal").style.display = "block";
  }
  
  function showModal(id) {
    document.getElementById(id).style.display = "block";
  }
  
  window.onclick = function (event) {
    if (
      event.target.id == "id01" ||
      event.target.id == "id02" ||
      event.target.id == "id03" ||
      event.target.id == "id04" ||
      event.target.id == "id05" ||
      event.target.id == "reportModal" ||
      event.target.id == "patientId"
     
    ) {
      document.getElementById(event.target.id).style.display = "none";
    }
  };
  
   
    
    function checkID() {
     if (identifier.patient === '' || identifier.sono === '' ) {
      showPatID();
      
     }
    }
  
  
  
  
  function showDiv(id) {
    var x = document.getElementById(id);
    if (x.className.indexOf("w3-show") == -1) {
      x.className += " w3-show";
    } else { 
      x.className = x.className.replace(" w3-show", "");
    }
  }    
  
  const history = {
      
      roi :"",
      side : '',
      region: '',
      text: '',
      symptoms: "",
     
      
      reportLine :function () {
        history.reportLine = clinReport();
      }
    };
    
    
    const identifier =  {
      patient: "",
      sono : "",
    }
    
    function getPatID() {
      
    document.querySelector("#patIdLine").innerHTML = boldString("Patient Identifier  -  ",'Patient Identifier') + identifier.patient
      document.querySelector("#sonoIdLine").innerHTML = boldString('Sonographer  -  ','Sonographer') + identifier.sono;
     // document.getElementById("hisTitle").innerHTML =  'Ultrasound ' + history.side + history.region; 
      document.getElementById("patientId").style.display = "none";
    }
    
    const pDSubBtn = document.querySelector("#patDetSub");
    pDSubBtn.addEventListener("click", (e) => {
      
      identifier.patient = document.getElementById('patDet').value;
      identifier.sono = document.getElementById('sono').value;
      getPatID();
      if (carpal.reported === true ) {
        populate();
      }
      console.log(e);
    });
  
  function prePopulate() {
    identifier.patient = document.getElementById('patDet').value;
      identifier.sono = document.getElementById('sono').value;
      getPatID();
      populate();
      showReportModal();
  }  
    
    
    const hisSymBtn = document.querySelectorAll(".hisSym");
    hisSymBtn.forEach((button) => {
      button.addEventListener("click", (e) => {
        history.symptoms = e.target.textContent;
        console.log(e);
      });
    });
    const hisRoiBtn = document.querySelectorAll(".hisRoi");
    hisRoiBtn.forEach((button) => {
      button.addEventListener("click", (e) => {
        history.roi = e.target.id;
        console.log(e);
      });
    });
    const hisSideBtn = document.querySelectorAll(".hisSide");
    hisSideBtn.forEach((button) => {
      button.addEventListener("click", (e) => {
        history.side = e.target.id;
       
        console.log(e);
      });
    });  
    const hisRegionBtn = document.querySelectorAll(".hisRegion");
    hisRegionBtn.forEach((button) => {
      button.addEventListener("click", (e) => {
        history.region = e.target.id;
        
        console.log(e);
      });
    }); 
    const hisText = document.querySelector("#hisText");
        hisText.addEventListener("focusout", (e) => {
              history.text = e.target.value;
              console.log(e);
            });
            
    function clinReport() { 
        history.reportLine =
           history.roi + history.symptoms + '. '+ history.text
        
    }
  
    
       
    
    function addClin() {
     
      clinReport();
      
      document.getElementById("hisRpt").innerHTML = boldString("Clinical Details - ","Clinical Details") + `${history.reportLine}`;
      }

     
    
      
      const carpalRpt = document.getElementById('carpalRpt')

      
function addTitle() {
if (history.side !== "" && history.region !== '')  {
     document.getElementById('titleRpt').innerHTML = `${history.side} ${history.region}`;
  } else  {
     checkSide();
  }
}


     
      
const sideBtn = document.querySelectorAll(".sideBtn")
const regionBtn = document.querySelectorAll(".hisRegion")
      sideBtn.forEach((button) => {
      button.addEventListener("click", function  (e)  {
      history.side = e.target.id;
      if (history.side !== "" && history.region !== '') {
        hideRequired();
        selectPopulate();
      }
     })});
     regionBtn.forEach((button) => {
      button.addEventListener("click", function  (e)  {
      history.region = e.target.id;
       if (history.side !== "" && history.region !== '') {
        hideRequired();
        selectPopulate();
       }
      
      })});
function selectPopulate() {

    if (carpal.reported === true) {
        carpalPopulate();
      }
      else {
        populate();
      }
      }
function checkSide() {
  
     document.getElementById('clinSection').click();
    
    };

      
        
  const carpal = {
    reported : false,
    name  : 'Carpal Tunnel ',
    rptID : 'carpal',
    CSAp : 0,
    CSAc : 0,
    dCSA : 0,
    CSAtext : ' is within normal limits. ',
    finding : '',
    other : '',
  }
  
  const carpalText = document.querySelectorAll('.carpalText')       
  carpalText.forEach((element) => {
     element.addEventListener('keyup', function (e) {
     let property = this.dataset.prop;
     carpal[property] = e.target.value;
     calculateCSAdiff(carpal);
         console.log(e);
     });
  });
  const carpalBtn = document.querySelectorAll(".carpalBtn")
  carpalBtn.forEach((button) => {
   button.addEventListener("click", function  (e)  {
   property = this.dataset.prop;
     carpal[property] = e.target.id;
     console.log(e);
   })
  })
  
  
  const carpalRepBtn = document.querySelector("#carpalRep");
        carpalRepBtn.addEventListener("click", (e) => {
          carpal.reported = true;
          carpalPopulate();
          console.log(e);
        });

  function carpalPopulate() {
          checkID();
          if (identifier.patient === '' || identifier.sono === '' ) {
            return
           }
          addTitle();
          addClin();
          addCarpal(carpal);
          displayDiv('carpal-table')
          if (history.side === "" || history.region === '') {
            return
          }
          showReportModal();
  }

  function calculateCSAdiff(obj) {
    if (obj.CSAc > 0 && obj.CSAp > 0) {
       let CSAdiff = obj.CSAc - obj.CSAp;
       obj.dCSA = CSAdiff.toFixed(1);
    }
    if (obj.CSAc > 11.9 && obj.dCSA < 2) {
      obj.CSAtext = " is normal, although the median nerve is enlarged, suggestive of CTS. ";
      obj.finding = ' The median nerve is enlarged at the carpal tunnel, suggestive of carpal tunnel syndrome. ' 
    } 
    if (obj.CSAc > 11.9 && obj.dCSA > 1.9) {
      obj.CSAtext = " is elevated, and the median nerve is enlarged, suggestive of CTS. ";
      obj.finding = ' The median nerve is enlarged at the carpal tunnel, suggestive of carpal tunnel syndrome. ' 
    } 
    if (obj.dCSA > 1.9 && obj.CSAc < 12) {
      obj.CSAtext = " is elevated, and suggestive of CTS. ";
      obj.finding = ' The median nerve is enlarged at the carpal tunnel, suggestive of carpal tunnel syndrome. ' 
    } 
    if (obj.dCSA < 2 && obj.CSAc < 12  ) {
      obj.CSAtext = " is within normal limits. ";
      obj.finding = " The median nerve has normal size and appearance. No evidence of carpal tunnel syndrome. "
    }
    if (obj.CSAc === 0) {
      return 
    } else {
       displayCSA(carpal);
    }
    }
    
   
  
  function displayCSA(obj) {
   
      document.getElementById('CSAdiff').innerHTML = 'The CSA difference of ' + obj.dCSA + 'mm2' + obj.CSAtext;

    
    document.getElementById('CSAdiffRpt').innerHTML = obj.dCSA;
    document.getElementById('CSApRpt').innerHTML = obj.CSAp;
    document.getElementById('CSAcRpt').innerHTML = obj.CSAc;
  }

  function addCarpal(obj) {
  
  document.getElementById(`${obj.rptID}Rpt`).innerHTML = `${boldString(obj.name +'  -  ', obj.name)}
  ${obj.finding}  ${obj.other}.` ;
  
  } 
  /*
  const thumb = {
    reported : false,
    side : '',
    name  : 'Thumb ',
    rptID : 'thumb',
    wrist : ' STTJ and RCJ Normal. ',
    cmcj : ' Normal. ',
    mcpj : " No effusion or synovitis. ",
    ucl : ' No evidence of UCL injury. ',
    rcl : ' RCL normal. ',
    volar : ' Volar plate intact. ',
    ipj : '',
    dequervains : ' No evidence of Dequervains tenosynovitis. ',
    trigger : ' FPL normal. ',
    tendon : ' No other tendon abnormaility. ',
    thenar : ' No thenar muscle injury. ',
    other : '',
  }
  
  
  const thumbText = document.querySelectorAll('.thumbText')       
  thumbText.forEach((element) => {
     element.addEventListener('focusout', function (e) {
     let property = this.dataset.prop;
     thumb[property] = e.target.value;
         console.log(e);
     });
  });
  const thumbBtn = document.querySelectorAll(".thumbBtn")
  thumbBtn.forEach((button) => {
   button.addEventListener("click", function  (e)  {
   property = this.dataset.prop;
     thumb[property] = e.target.id;
     console.log(e);
   })
  })
  
  
  const thumbRepBtn = document.querySelector("#thumbRep");
        thumbRepBtn.addEventListener("click", (e) => {
          thumb.reported = true;
          thumbPopulate();
          console.log(e);
    
  function thumbPopulate() {
          checkID();
          if (identifier.patient === '' || identifier.sono === '' ) {
            return
           }
          addThumbTitle();
          addClin();
          defineThumbRoi();
          addThumbJoints(thumb);
          addThumbTendons(thumb);
          if (history.side === "" || history.region === '') {
            return
          }
          showReportModal();
  }
  
  function defineThumbRoi() {
    if (thumb.mcpj === " No effusion or synovitis. " && thumb.ucl === ' No evidence of UCL injury. ' 
    && thumb.rcl === ' RCL normal. ' && thumb.volar === ' Volar plate intact. ' && thumb.cmcj !== ' Normal. ') {
      thumb.mcpj = ' Normal. ';
    }
  }
  
  function addThumbJoints(obj) {
  if (thumb.mcpj === ' Normal. ') {
    document.getElementById(`${obj.rptID}Rpt1`).innerHTML = `${boldString('1st CMCJ  -  ', '1st CMCJ')}
    ${obj.cmcj}  ${obj.wrist}  ${obj.mcpj}` ;
    }
  else {
    document.getElementById(`${obj.rptID}Rpt1`).innerHTML = `${boldString('1st MCPJ  -  ', '1st MCPJ')}
    ${obj.mcpj}  ${obj.ucl}  ${obj.rcl} ${obj.volar} ${obj.thenar}` ;
    document.getElementById(`${obj.rptID}Rpt2`).innerHTML = `${boldString('1st CMCJ  -  ', '1st CMCJ')}
    ${obj.cmcj}  ${obj.wrist}  ${obj.ipj}` ;
    }
  }
  
  function addThumbTendons(obj) {
    document.getElementById(`${obj.rptID}Rpt3`).innerHTML = `${boldString('Tendons  -  ', 'Tendons')}
    ${obj.dequervains}  ${obj.trigger}  ${obj.tendon}`;
    document.getElementById(`${obj.rptID}Rpt4`).innerHTML = `${obj.other}`;
    }
  
  */
  
  class tendon {
    constructor() {
      this.number = '',
      this.id = '',
      
      this.grade = '';
      this.neovasc = '';
      this.anatomy = '';
      this.anatText = '';
      this.sheath = '';
      this.texture = '';
      this.pulley = '';
      this.formatted = '';
      
      this.other = '';
    }
    }
         const rightTendonList = [];
         let rightFilteredTendonList = [];
         function filterRightTendon() {
          rightFilteredTendonList = rightTendonList.filter(function(element){ 
           return  (element.anatomy !== '' || element.anatText !== '') 
         });
         }
         
         
         let newTendon = rightTendonList.at(-1);
         let tendonRptNumber = rightTendonList.length;
         let newTendonId = 'rightTendonRpt' + tendonRptNumber;
  
         
         
        const righttendonRepBtn = document.querySelector("#rightTendonRep");
        righttendonRepBtn.addEventListener("click", (e) => {
          e.preventDefault();
          formatRpt(newTendon);
          addClin();
          checkID();
          showDiv('rightTendon');
          
          addTendon(newTendon);
          addRightNormalTendon();
          showReportModal();
          console.log(e);
        });
        
        function addRightTendonRpt() {
        let newRpt = document.createElement('p');
        newRpt.setAttribute('id', newTendon.id);
        newRpt.classList.add('reportText');
        newRpt.textContent = '';
        rightWorksheet.insertBefore(newRpt,rightNormTendonRpt);
        }
        
        const rightTendonDiv = document.getElementById('rightTendon')
  
        const newRightTendonBtn = document.getElementById('rightNewTendon');
        newRightTendonBtn.addEventListener('click', () => {
        rightTendonList.push(new tendon);
        newTendon = rightTendonList.at(-1);
        newTendon.number = rightTendonList.length;
        newTendon.id = `rightTendonRpt${newTendon.number}`;
        addRightTendonRpt();
        addRightNormalTendon();
        showDiv('rightTendon')
        clearTendonText();
        
        })
        
        const rightNormTendonRpt = document.getElementById('rightNormTendonRpt');
    
                 function addRightNormalTendon() {
                   filterRightTendon();
  
                 if (rightFilteredTendonList.length === 0) {
                   document.getElementById('rightNormTendonRpt').innerHTML = 'No tendon abnormality identified.'
                 } else {
                     document.getElementById('rightNormTendonRpt').innerHTML = "No other tendon abnormality identified.";
                 }
                 } 
      
                 
                   function clearTendonText() {
                   document.getElementById('tendonText').value = '';
                   document.getElementById('tendonAnatText').value = '';
                   }
                 function addTendon(element) {
                   formatRpt(newTendon)
                   if (element.anatomy !== '' && element.anatText !== '') {
                    document.getElementById(element.id).innerHTML = element.formatted + element.anatText + element.sheath + element.texture + element.neovasc + element.pulley + element.other + element.grade ; 
                   }
                   else {
                    document.getElementById(element.id).innerHTML = element.formatted + element.sheath + element.texture + element.neovasc + element.pulley + element.other + element.grade; 
                   }
                   
                 }
                   
                   
                 function addRightTendon() {
                  filterRightTendon();
                 rightFilteredTendonList.forEach(function (element) {
                         document.getElementById(element.id).innerHTML =  element.formatted + element.texture + element.grade + element.other; 
                     }
                 )};
  
                 function formatRpt(element) {
                  if (element.anatomy === '') {
                    element.formatted = boldString(element.anatText +'  -  ',element.anatText)
                  } else {
                    element.formatted = boldString(element.anatomy +'  -  ',element.anatomy) 
                  }
                  
                  }
                 
  
  const tendonAnatBtn = document.querySelectorAll('.tendonAnat');
  tendonAnatBtn.forEach((button) => {
      button.addEventListener('click',(e) => {
          newTendon.anatomy = e.target.id;
      });
  });
  const tendonSheathBtn = document.querySelectorAll('.tendonSheath');
  tendonSheathBtn.forEach((button) => {
      button.addEventListener('click',(e) => {
          newTendon.sheath = e.target.id;
      });
  });
  const tendonNeovascBtn = document.querySelectorAll('.tendonVasc');
  tendonNeovascBtn.forEach((button) => {
      button.addEventListener('click',(e) => {
          newTendon.neovasc = e.target.id;
      });
  });
  const tendonPulleyBtn = document.querySelectorAll('.tendonPulley');
  tendonPulleyBtn.forEach((button) => {
      button.addEventListener('click',(e) => {
          newTendon.pulley = e.target.id;
      });
  });
  const tendonTextureBtn = document.querySelectorAll('.tendonTexture');
  tendonTextureBtn.forEach((button) => {
      button.addEventListener('click',(e) => {
          newTendon.texture = e.target.id;
      });
  });
  const tendonGradeBtn = document.querySelectorAll('.tendonGrade');
  tendonGradeBtn.forEach((button) => {
      button.addEventListener('click',(e) => {
          newTendon.grade = e.target.id;
      });
  });
  const tendonText = document.querySelector('#tendonText')
    tendonText.addEventListener("focusout", (e) => {
        newTendon.other = e.target.value;
    });
    const tendonAnatText = document.querySelector('#tendonAnatText')
    tendonAnatText.addEventListener("focusout", (e) => {
        newTendon.anatText = e.target.value;
    });

  // -----------------------joint.js-----------------------------------//
  //-------------------------------------------------------------------------//
  
  
  class joint {
    constructor() {
      this.number = '',
      this.id = '',
      this.anatomy = '';
      this.anatText = '';
      this.effusion = '';
      this.other = '';
      this.osteophytes = '';
      this.ganglion = '';
      this.dimension = '';
      this.formatted = '';
    }
    }
  
  const jointAnatBtn = document.querySelectorAll('.jointAnat');
    jointAnatBtn.forEach((button) => {
        button.addEventListener('click',(e) => {
            newJoint.anatomy = e.target.id;
        });
    });
    const jointEffusionBtn = document.querySelectorAll('.jointEffusion');
    jointEffusionBtn.forEach((button) => {
        button.addEventListener('click',(e) => {
            newJoint.effusion = e.target.id;
        });
    });
    const jointOsteoBtn = document.querySelectorAll('.jointOsteo');
    jointOsteoBtn.forEach((button) => {
        button.addEventListener('click',(e) => {
            newJoint.osteophytes = e.target.id;
        });
    });
  
    const jointGanglionBtn = document.querySelectorAll('.jointGanglion');
    jointGanglionBtn.forEach((button) => {
        button.addEventListener('click',(e) => {
            newJoint.ganglion = e.target.id;
        });
    });
    const jointText = document.querySelector('#jointText')
    jointText.addEventListener("focusout", (e) => {
        newJoint.other = e.target.value;
    });
    const jointAnatText = document.querySelector('#jointAnatText')
    jointAnatText.addEventListener("focusout", (e) => {
        newJoint.anatText = e.target.value;
    });
    const jointDimension = document.querySelector('#jointDimension')
    jointDimension.addEventListener("focusout", (e) => {
        newJoint.dimension = e.target.value;
    });
  
    const rightJointList = [];
     let rightFilteredJointList = [];
  
     function filterRightJoint() {
      rightFilteredJointList = rightJointList.filter(function(element){ 
       return  ((element.anatomy !== '' || element.anatText!== '') && (element.effusion !== '' || element.osteophytes !== '' || element.ganglion !== '')) 
     });
     }
  
     
     let newJoint = rightJointList.at(-1);
     let jointRptNumber = rightJointList.length;
     let newJointId = 'rightJointRpt' + jointRptNumber;
  
     
    const rightJointRepBtn = document.querySelector("#rightJointRep");
    rightJointRepBtn.addEventListener("click", (e) => {
      e.preventDefault();
      checkID();
      addClin();
      showDiv('rightJoint');
      
      addJoint(newJoint);
      addRightNormalJoint();
      showReportModal();
      console.log(e);
    });
    
    function addRightJointRpt() {
    let newRpt = document.createElement('p');
    newRpt.setAttribute('id', newJoint.id);
    newRpt.classList.add('reportText');
    newRpt.textContent = '';
    rightWorksheet.insertBefore(newRpt,rightNormJointRpt);
    }
    
    const rightJointDiv = document.getElementById('rightJoint')
  
    const newRightJointBtn = document.getElementById('rightNewJoint');
    newRightJointBtn.addEventListener('click', () => {
    rightJointList.push(new joint);
    newJoint = rightJointList.at(-1);
    newJoint.number = rightJointList.length;
    newJoint.id = `rightJointRpt${newJoint.number}`;
    addRightJointRpt();
    clearJointText();
    showDiv('rightJoint');
    
    
    })
    
    
    
    const rightNormJointRpt = document.getElementById('rightNormJointRpt');
         
             
   function addRightNormalJoint() {
     filterRightJoint();
   if (rightFilteredJointList.length === 0) {
     document.getElementById('rightNormJointRpt').innerHTML = `No joint effusion or synovitis. No evidence of degenerative arthropathy.`;
   } else {
       document.getElementById('rightNormJointRpt').innerHTML = "No other joint abnormality identified.";
   }
   } 
   
     
     function clearJointText() {
     document.getElementById('jointText').value = '';
     document.getElementById('jointAnatText').value = '';
     document.getElementById('jointDimension').value = '';
     }
     function addJoint(element) {
      formatRpt(newJoint);
      if (element.anatomy !== '' && element.anatText !== '') {
        document.getElementById(element.id).innerHTML = `${element.formatted + element.anatText + element.effusion + element.other} ${element.osteophytes + element.dimension} ${element.ganglion}`; 
      } else {
       document.getElementById(element.id).innerHTML = `${element.formatted + element.effusion + element.other} ${element.osteophytes + element.dimension} ${element.ganglion}`; 
      }
      }
     
   function addRightJoint() {
   filterRightJoint(rightFilteredJointList, rightJointList);
   rightFilteredJointList.forEach(function (element) {
           document.getElementById(element.id).innerHTML =  `${element.formatted + element.effusion + element.osteophytes + element.dimension} ${element.ganglion}${element.other}`; 
       }
   )};
  
    //---------------ligament.js--------------------------------------------------//
  
  
  class ligament {
    constructor() {
      this.number = '',
      this.id = '',
      
      this.grade = '';
      
      this.anatomy = '';
      this.anatText = '';
      this.texture = '';
      this.textureText = '';
      this.formatted = ''
      this.other = '';
    }
    }
    function formatRpt(element) {
      if (element.anatomy === '') {
        element.formatted = boldString(element.anatText +'  -  ',element.anatText)
      } else {
        element.formatted = boldString(element.anatomy +'  -  ',element.anatomy) 
      }
      
      }
      
         
         function removeRightInvalidEntries() {
          rightFilteredLigList = rightLigamentList.filter(function(element){ 
           return  (element.anatomy !== '' || element.anatText !== '') 
         });
         }
         const rightLigamentList = [];
         let rightFilteredLigList = [];
         
         let newLigament = rightLigamentList.at(-1);
         let ligamentRptNumber = rightLigamentList.length;
         let newLigamentId = 'rightLigamentRpt' + ligamentRptNumber;
  
         const rightNewBtns = document.getElementById('rightNewBtns')
         
         function hideDiv(id) {
         document.getElementById(id).style.display = 'none';
         }
         
        const rightligamentRepBtn = document.querySelector("#rightLigamentRep");
        rightligamentRepBtn.addEventListener("click", (e) => {
          e.preventDefault();
          formatRpt(newLigament);
          addClin();
          checkID();
          showDiv('rightLigament');
          
          addLigament(newLigament);
          addRightNormalLigament();
          showReportModal();
          console.log(e);
        });
        
        function addRightLigamentRpt() {
        let newRpt = document.createElement('p');
        newRpt.setAttribute('id', newLigament.id);
        newRpt.classList.add('reportText');
        newRpt.textContent = '';
        rightWorksheet.insertBefore(newRpt,rightNormLigRpt);
        }
        
        const rightLigamentDiv = document.getElementById('rightLigament')
  
        const newRightLigamentBtn = document.getElementById('rightNewLigament');
        newRightLigamentBtn.addEventListener('click', () => {
        rightLigamentList.push(new ligament);
        newLigament = rightLigamentList.at(-1);
        newLigament.number = rightLigamentList.length;
        newLigament.id = `rightLigamentRpt${newLigament.number}`;
        addRightLigamentRpt();
        
        showDiv('rightLigament')
        clearLigamentText();
        
        
        
        })
        
        
      
        const rightWorksheet = document.getElementById('rightWorksheet');
        const rightNormLigRpt = document.getElementById('rightNormLigRpt');
    
      
                 
                 
                 function addRightNormalLigament() {
                   removeRightInvalidEntries()
  
                 if (rightFilteredLigList.length === 0) {
                   document.getElementById('rightNormLigRpt').innerHTML = 'Ligaments appear intact with no evidence of acute injury.'
                 } else {
                     document.getElementById('rightNormLigRpt').innerHTML = "No other ligament abnormality identified.";
                 }
                 } 
      
                 
                   function clearLigamentText() {
                   document.getElementById('ligamentAnatText').value = '';
                   document.getElementById('ligamentText').value = '';
                   }
                 function addLigament(element) {
                   formatRpt(newLigament);
                   if (element.anatomy !== '' && element.anatText !== '') {
                     document.getElementById(element.id).innerHTML = element.formatted + element.anatText + element.texture + element.other + element.grade; 
                   } else {
                    document.getElementById(element.id).innerHTML = element.formatted + element.texture + element.other + element.grade; 
                   }
                   }
                   
                   
                 function addRightLigament() {
                  removeRightInvalidEntries()
                 rightFilteredLigList.forEach(function (element) {
                         document.getElementById(element.id).innerHTML =  element.formatted + element.texture + element.grade + element.other; 
                     }
                 )};
  
  
                 
  
  const ligamentAnatBtn = document.querySelectorAll('.ligAnat');
  ligamentAnatBtn.forEach((button) => {
      button.addEventListener('click',(e) => {
          newLigament.anatomy = e.target.id;
          formatRpt(newLigament);
      });
  });
  const ligamentTextureBtn = document.querySelectorAll('.ligTexture');
  ligamentTextureBtn.forEach((button) => {
      button.addEventListener('click',(e) => {
          newLigament.texture = e.target.id;
      });
  });
  const ligamentGradeBtn = document.querySelectorAll('.ligGrade');
  ligamentGradeBtn.forEach((button) => {
      button.addEventListener('click',(e) => {
          newLigament.grade = e.target.id;
      });
  });
  const ligamentText = document.querySelector('#ligamentText')
    ligamentText.addEventListener("focusout", (e) => {
        newLigament.other = e.target.value;
    });
    const ligamentAnatText = document.querySelector('#ligamentAnatText')
    ligamentAnatText.addEventListener("focusout", (e) => {
        newLigament.anatText = e.target.value;
        formatRpt(newLigament);
    });
      const globalRepBtn = document.querySelector("#globalRep");
        globalRepBtn.addEventListener("click", (e) => {
          populate();
          console.log(e);
        });
        
    
  function populate() {
    checkID();
    if (identifier.patient === '' || identifier.sono === '' ) {
      return
     }
    addClin();
    addRightNormalTendon();
    addRightNormalLigament();
    addRightNormalJoint();
    addTitle();
    if (history.side === "" || history.region === '') {
      return
    }
     showReportModal();
  };
  
  /*
  const buttons = Array.from(document.getElementsByTagName('button'));
  buttons.forEach((element) =>  {
    element.addEventListener('click',(e) => {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
    });
      console.log(e);
    })
  });
  */
  
  
  
  const reOpenWSBtn = document.querySelector("#savRep");
  reOpenWSBtn.addEventListener("click", () => {
    showModal('reportModal');
  });
  
  const panels = Array.from(document.getElementsByClassName('w3-panel'));
  panels.forEach((element) =>  {
    element.addEventListener('click',(e) => {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
    });
      console.log(e);
    })
  });
  
  function hideRequired() {
    let required = document.querySelectorAll('.required')
    required.forEach( function (element) {
      element.style.display = 'none';

    })
  };
  
  function hideElements(array) {
    array.forEach(function (element) {
      element.style.display = 'none';
    })
  }   function displayElements(array) {
   array.forEach(function (element) {
     element.style.display = 'inline';
   })
  }  
  function hideDiv(id) {
  document.getElementById(id).style.display = 'none';
  }
  function displayDiv(id) {
    document.getElementById(id).style.display = 'inline'
  }
  